import React, { useState, useEffect } from 'react';
import icon from '../images/icon-v.png';
import instructions from '../images/instruct-v.png';
import Rinstructions from '../images/r-instruct-v.png';

const SlideComponent = ({ actual, first, second }) => {
  const [selectedButtonGroup1, setSelectedButtonGroup1] = useState(null);
    const [selectedButtonGroup2, setSelectedButtonGroup2] = useState(null);
    const [title, setTitle] = useState(null);
  const [disableNextButton, setDisableNextButton] = useState(true);

    useEffect(() => {
        const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '[]');
        const savedTest = JSON.parse(localStorage.getItem('currentTest') || '[]');
        setTitle(savedTest.title);
        console.log(savedAnswer);
        const savedButtonGroup1 = savedAnswer.selectedButtonGroup0;
        console.log(savedButtonGroup1);
        const savedButtonGroup2 = savedAnswer.selectedButtonGroup1;

        if (savedButtonGroup1) {
            setSelectedButtonGroup1(savedButtonGroup1);
        }

        if (savedButtonGroup2) {
            setSelectedButtonGroup2(savedButtonGroup2);
        }
    }, []);

    useEffect(() => {
        const nextButton = document.querySelector('.btn-next');

        if (selectedButtonGroup1 !== null && selectedButtonGroup2 !== null) {
            nextButton.disabled = false; // Habilitar el botón
        } else {
            nextButton.disabled = true; // Deshabilitar el botón
        }
    }, [selectedButtonGroup1, selectedButtonGroup2]);


    
    const handleQuitInstructions = () => {
        const instructionsDiv = document.getElementById('instructions-div');
        if (instructionsDiv) {
            instructionsDiv.style.display = 'none';
        }
    };
  return (
      <div className="slide-container">
          <div className="overlay" id="instructions-div">
              <img src={instructions} alt="Imagen" className="centered-image dekstop" onClick={handleQuitInstructions} />
              <img src={Rinstructions} alt="Imagen" className="centered-image mobile" onClick={handleQuitInstructions} />
          </div>
          <img className="icon-test" src={icon} alt="icon" />
          <div className="actual-wine">{title}</div>
      <h2 className="mb-3">¡¡¡   Fase visual   !!!</h2>

      
      
      <div className="section-container" role="group">
              <div className="section-title">Intensidad del color</div>
              {first.question.map((item, index) => (
                  <button
                      key={index}
                      type="button"
                      className={`btn ${selectedButtonGroup1 === item.option ? 'btn-selected' : 'btn-olfatory'}`}
                  >
                      {item.option}
                  </button>
              ))}
      </div>

      <div className="section-container">
      <div className="section-title">Color del Vino</div>
              {second.question.map((item, index) => (
                  <button
                      key={index}
                      type="button"
                      className={`btn ${selectedButtonGroup2 === item.option ? 'btn-selected' : 'btn-olfatory'}`}
                  >
                      {item.option}
                  </button>
              ))}
      </div>
    </div>
  );
};

export default SlideComponent;